import {
  type PermissionRouteGuardData,
  PermissionRouteGuard,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function LOSDetailsLayout() {
  const { structureId } = useParams('/qbank-structures/:structureId');

  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/qbank-structures/:structureId/los/:losId/questions',
      requiredPermission: [APP_PERMISSIONS.QBANK.LOS.VIEW],
      params: { structureId },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <Outlet />
    </PermissionRouteGuard>
  );
}
